import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { TokenInterceptor } from './service/interceptor/token.interceptor';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { LoaderComponent } from './shared/components/loader/loader.component';
import {
  LocationStrategy,
  HashLocationStrategy,
  DatePipe,
} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatTableModule } from '@angular/material/table';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { reducers, metaReducers } from './reducers';
import { UserMappingEffect } from './state/userMap.effect';
import { AuthEffect } from './modules/auth/state/effect';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { SharedModule } from './modules/shared/shared.module';
import { QrCodeStatusComponent } from './shared/components/qr-code-status/qr-code-status.component';
import { QueryComponent } from './shared/components/query/query.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DasboardModule } from './modules/dasboard/dasboard.module';
import { CourseModalComponent } from './shared/components/course-modal/course-modal.component';
import { MedicalModalComponent } from './shared/components/medical-modal/medical-modal.component';
import { PassportModalComponent } from './shared/components/passport-modal/passport-modal.component';
import { VisaModalComponent } from './shared/components/visa-modal/visa-modal.component';
import { ItemListComponent } from './shared/components/item-list/item-list.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { BlankLayoutComponent } from './blankTemp/blank-layout/blank-layout.component';
import { LeaveApprovalComponent } from './shared/components/approvals/leave-approval/leave-approval.component';
import { MrfApprovalComponent } from './shared/components/approvals/mrf-approval/mrf-approval.component';
import { ExpenseApprovalComponent } from './shared/components/approvals/expense-approval/expense-approval.component';
import { AllApprovalComponent } from './shared/components/approvals/all-approval/all-approval.component';
import { CarouselModule } from 'ngx-owl-carousel-o';

// import { DropZoneDirective } from './service/directives/dropZone/drop-zone.directive';
// tslint:disable-next-line: typedef
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    BlankComponent,
    FullComponent,
    NotFoundComponent,
    HeaderComponent,
    SidebarComponent,
    LoaderComponent,
    QrCodeStatusComponent,
    ItemListComponent,
    BlankLayoutComponent,
    LeaveApprovalComponent,
    MrfApprovalComponent,
    ExpenseApprovalComponent,
    AllApprovalComponent,
    // DropZoneDirective,
  ],
  imports: [
    CarouselModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DasboardModule,
    UiSwitchModule,
    DragDropModule,
    MatTableModule,
    ToastrModule.forRoot(),
    NgHttpLoaderModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([AuthEffect, UserMappingEffect]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    NgxCaptchaModule,
    SharedModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
